import { sva } from '@agapi/ui/panda/css'

export const blogPageStyles = sva({
  slots: ['section', 'sectionContainer', 'heading', 'subTitle', 'nav', 'categoryButton', 'postGrid', 'loadMoreContainer'],
  base: {
    section: {
      backgroundColor: 'surface.primary.subdued.background/30!',
    },
    sectionContainer: {
      display: 'flex', flexDirection: 'column', gap: '4', justifyContent: 'center', alignItems: 'center'
    },
    heading: {
      color: 'text.heading',
      textAlign: 'center',
    },
    subTitle: {
      fontSize: 'lg',
      color: 'text.vibrant',
      textAlign: 'center',
    },
    nav: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: '4',
      marginBottom: '4',
    },
    postGrid: {
      display: 'grid',
      gridTemplateColumns: { base: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)', lg: 'repeat(3, 1fr)' },
      gap: '6',
    },
    loadMoreContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '2rem',
    },
  },
});